import { useCallback } from 'react';

import {
  ApprovalDecision,
  DoBoxEntryKind,
  InboxEntry,
} from '@this+that/models';

import { useRespondToBrainReview } from './useRespondToBrainReview';
import { useRespondToBrainSignalReview } from './useRespondToBrainSignalReview';
import { useRespondToFlowApproval } from './useRespondToFlowApproval';

export const useRespondToApprovalEntry = () => {
  const { respondToFlowApproval, isResponding: isRespondingToFlow } =
    useRespondToFlowApproval();
  const { respondToBrainReview, isResponding: isRespondingToBrain } =
    useRespondToBrainReview();
  const { respondToBrainSignalReview, isResponding: isRespondingToSignal } =
    useRespondToBrainSignalReview();

  const respondToApprovalEntry = useCallback(
    (entry: InboxEntry, decision: ApprovalDecision): Promise<boolean> => {
      if (entry.entryKind === DoBoxEntryKind.BRAIN_REVIEW) {
        return respondToBrainReview(entry, decision);
      }
      if (entry.entryKind === DoBoxEntryKind.BRAIN_SIGNAL_REVIEW) {
        return respondToBrainSignalReview(entry, decision);
      }
      return respondToFlowApproval(entry, decision);
    },
    [respondToBrainReview, respondToBrainSignalReview, respondToFlowApproval],
  );

  return {
    respondToApprovalEntry,
    isResponding:
      isRespondingToFlow || isRespondingToBrain || isRespondingToSignal,
  };
};
